module.exports = __webpack_public_path__ + "02_long_brown.9b65000e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_long_brown.png
// module id = mTgg
// module chunks = 0